export function getDateFormatted(date) {
  // Formatting Date YYYY MM DD
  const dateParts = date.split('-'); // Ej: ["2025", "11", "03"]
  const localDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]); // Meses en JS van de 0 a 11

  let dateString = localDate.toString()
  let day
  let month
  var numberDay = dateString.substr(8, 2)

  switch (dateString.substr(0, 3)) {
    case 'Mon':
      day = 'Lun'
      break
    case 'Tue':
      day = 'Mar'
      break
    case 'Wed':
      day = 'Mie'
      break
    case 'Thu':
      day = 'Jue'
      break
    case 'Fri':
      day = 'Vie'
      break
    case 'Sat':
      day = 'Sábado'
      break
    case 'Sun':
      day = 'Domingo'
      break
    default:
      break
  }

  switch (dateString.substr(4, 3)) {
    case 'Jan':
      month = 'Enero'
      break
    case 'Feb':
      month = 'Febrero'
      break
    case 'Mar':
      month = 'Marzo'
      break
    case 'Apr':
      month = 'Abril'
      break
    case 'May':
      month = 'Mayo'
      break
    case 'Jun':
      month = 'Junio'
      break
    case 'Jul':
      month = 'Julio'
      break
    case 'Aug':
      month = 'Agosto'
      break
    case 'Sep':
      month = 'Septiembre'
      break
    case 'Oct':
      month = 'Octubre'
      break
    case 'Nov':
      month = 'Noviembre'
      break
    case 'Dec':
      month = 'Diciembre'
      break
    default:
      break
  }

  return {
    day: day,
    month: month,
    numberDay: numberDay
  }
}
